import { render, staticRenderFns } from "./updBkmt.vue?vue&type=template&id=a55f2b7e"
import script from "./updBkmt.vue?vue&type=script&lang=js"
export * from "./updBkmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports